var moduleMap = {
	"./toAbsoluteUrl": () => {
		return __webpack_require__.e(513).then(() => (() => ((__webpack_require__(10513)))));
	},
	"./commonservice": () => {
		return Promise.all([__webpack_require__.e(4929), __webpack_require__.e(7586), __webpack_require__.e(4159), __webpack_require__.e(7138), __webpack_require__.e(1243), __webpack_require__.e(9282)]).then(() => (() => ((__webpack_require__(91243)))));
	},
	"./ModelNewView": () => {
		return Promise.all([__webpack_require__.e(7680), __webpack_require__.e(4914), __webpack_require__.e(4929), __webpack_require__.e(7586), __webpack_require__.e(4159), __webpack_require__.e(7138), __webpack_require__.e(1243), __webpack_require__.e(4503), __webpack_require__.e(4504), __webpack_require__.e(307)]).then(() => (() => ((__webpack_require__(24504)))));
	},
	"./metadataservice": () => {
		return Promise.all([__webpack_require__.e(4929), __webpack_require__.e(7586), __webpack_require__.e(4159), __webpack_require__.e(7138), __webpack_require__.e(343)]).then(() => (() => ((__webpack_require__(10196)))));
	},
	"./profile": () => {
		return Promise.all([__webpack_require__.e(4929), __webpack_require__.e(7586), __webpack_require__.e(4159), __webpack_require__.e(7138), __webpack_require__.e(5937)]).then(() => (() => ((__webpack_require__(71358)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});